const types = {
    INITIAL_LOAD: 'setInitialData',
    SET_TOURNAMENTS: 'setTournaments',
    JOIN_TOURNAMENT: 'joinTournament',
    QUIT_TOURNAMENT: 'quitTournament',
    UPDATE_PLAYERS: 'updatePlayerList',
    SET_NEW_TOURNAMENT: 'setNewTournament',
    OPEN_TOURNAMENT_REGISTRATION: 'openTournamentRegistration',
    UPDATE_TOURNAMENT: 'updateTournament',
    SET_SIDEBAR_TOURNAMENT_ID: 'setSideBarTournamentId',
    UPDATE_TOURNAMENT_BETTING_TIMER: 'updateTournamentBettingTimer',
    DELETE_TOURNAMENT: 'deleteTournament',
    UPDATE_TOP_WINNERS: 'updateTopWinners',
};
export default types
